import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Users, BarChart3 } from 'lucide-react'

interface PartnerTypesSectionProps {
  className?: string
}

const PartnerTypesSection: React.FC<PartnerTypesSectionProps> = ({ className }) => {
  const partnerTypes = [
    {
      type: "Distribution Partners",
      description: "Perfect for communities managing investors looking to tap into this business",
      benefits: [
        "Zero integration cost",
        "Immediate deal access",
        "Revenue sharing up to 30%",
        "Official partner certification"
      ],
      examples: ["Legion"],
      icon: <Users size={24} className="text-gray-700 dark:text-gray-300" />
    },
    {
      type: "Orderbook Partners", 
      description: "Broker-dealer partnerships that share deal flow and liquidity",
      benefits: [
        "Plug in your orderbook",
        "Lock in your margins",
        "Connect to our liquidity highway",
        "Close deals faster"
      ],
      examples: ["RainMaker", "Hiive"],
      icon: <BarChart3 size={24} className="text-gray-700 dark:text-gray-300" />
    }
  ]

  return (
    <div className={className}>
      <div className="flex items-center gap-2 mb-6">
        <Users className="text-blue-600 dark:text-blue-500" size={20} />
        <h2 className="text-xl font-semibold text-[var(--text)]">Choose Your Partnership Type</h2>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {partnerTypes.map((partner, index) => (
          <Card key={index} variant="elevated" className="hover:border-primary-500/30 transition-colors">
            <CardContent className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gray-100 dark:bg-gray-800 flex items-center justify-center rounded-full">
                  {partner.icon}
                </div>
                <h3 className="text-xl font-semibold text-[var(--foreground)]">{partner.type}</h3>
              </div>
              
              <p className="text-[var(--muted-foreground)] text-sm mb-4">{partner.description}</p>
              
              <div className="mb-4">
                <h4 className="font-medium text-[var(--foreground)] mb-2 text-sm">Key Benefits:</h4>
                <ul className="space-y-1">
                  {partner.benefits.map((benefit, benefitIndex) => (
                    <li key={benefitIndex} className="flex items-center gap-2">
                      <div className="w-1.5 h-1.5 bg-primary-500 rounded-full"></div>
                      <span className="text-[var(--muted-foreground)] text-sm">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}

export default PartnerTypesSection 